import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-multi-yuri';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="left-card" data-center-y="false" data-order="1" class="left-card"
      style="order: 1; --center-y: start;">
      <div data-attribute="title-card" data-show-title="true" class="title-card" style="display: block;">
        <h2 style="text-align:center;"><span style="color:hsl(0,0%,90%);">Why Women Choose</span><br><span
            style="color:hsl(0,0%,90%);"><i>Yuri™ Collagen Overnight Mask</i></span></h2>
        <p style="text-align:center;"><span style="color:hsl(0,0%,90%);">Wake up to skin that feels firmer, brighter,
            and deeply hydrated. Yuri’s innovative overnight formula restores elasticity, smooths fine lines, and locks
            in long-lasting moisture while you sleep.</span></p>
      </div>
      <div class="box-list-item" data-attribute="box-list-item" data-background-box="#ffffff33" data-color-box="#ffffff"
        data-show="true" style="--background-box: #ffffff33; --color-box: #ffffff; display: block;">
        <div data-attribute="item-on-box" class="wrap-item">
          <div class="head-item">
            <div class="icon-left">
              <img data-attribute="icon-item"
                src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fdb0053f24fbe2de75c2cc.png" alt="">
            </div>
            <div data-attribute="head-item" class="text-right-item">
              <p>60-Day Money Back Guarantee</p>
            </div>
          </div>
          <div data-attribute="content-item" class="content-item">
            <p>Collagen Extract helps improve elasticity and resilience, leaving skin feeling firmer and more youthful.
            </p>
          </div>
        </div>

        <div data-attribute="item-on-box" class="wrap-item">
          <div class="head-item">
            <div class="icon-left">
              <img data-attribute="icon-item"
                src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fdb0053f24fbe2de75c2cc.png" alt="">
            </div>
            <div data-attribute="head-item" class="text-right-item">
              <p>60-Day Money Back Guarantee</p>
            </div>
          </div>
          <div data-attribute="content-item" class="content-item">
            <p>Collagen Extract helps improve elasticity and resilience, leaving skin feeling firmer and more youthful.
            </p>
          </div>
        </div>

        <div data-attribute="item-on-box" class="wrap-item">
          <div class="head-item">
            <div class="icon-left">
              <img data-attribute="icon-item"
                src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fdb0053f24fbe2de75c2cc.png" alt="">
            </div>
            <div data-attribute="head-item" class="text-right-item">
              <p>60-Day Money Back Guarantee</p>
            </div>
          </div>
          <div data-attribute="content-item" class="content-item">
            <p>Collagen Extract helps improve elasticity and resilience, leaving skin feeling firmer and more youthful.
            </p>
          </div>
        </div>
      </div>

      <div data-attribute="pill-list-item" class="pill-group" data-show="true" data-background-pill="#ffffff"
        data-color-pill="#000000" style="--background-color-pill: #ffffff; --color-pill: #000000; display: flex;">
        <div data-attribute="pill-item" class="wrap-item">
          <div class="left-icon">
            <img data-attribute="icon-item"
              src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fda80e39a3d8e05ec42bdb.png" alt="">
          </div>
          <div data-attribute="text-item" class="right-item-text">
            <p>Restores Elasticity</p>
          </div>
        </div>

        <div data-attribute="pill-item" class="wrap-item">
          <div class="left-icon">
            <img data-attribute="icon-item"
              src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fda80e39a3d8e05ec42bdb.png" alt="">
          </div>
          <div data-attribute="text-item" class="right-item-text">
            <p>Restores Elasticity</p>
          </div>
        </div>

        <div data-attribute="pill-item" class="wrap-item">
          <div class="left-icon">
            <img data-attribute="icon-item"
              src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fda80e39a3d8e05ec42bdb.png" alt="">
          </div>
          <div data-attribute="text-item" class="right-item-text">
            <p>Restores Elasticity</p>
          </div>
        </div>

        <div data-attribute="pill-item" class="wrap-item">
          <div class="left-icon">
            <img data-attribute="icon-item"
              src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fda80e39a3d8e05ec42bdb.png" alt="">
          </div>
          <div data-attribute="text-item" class="right-item-text">
            <p>Restores Elasticity</p>
          </div>
        </div>

        <div data-attribute="pill-item" class="wrap-item">
          <div class="left-icon">
            <img data-attribute="icon-item"
              src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fda80e39a3d8e05ec42bdb.png" alt="">
          </div>
          <div data-attribute="text-item" class="right-item-text">
            <p>Restores Elasticity</p>
          </div>
        </div>
      </div>

    </div>
    <div data-attribute="right-card" data-order="2" class="right-card" style="order: 2;">
      <div data-show="true" data-attribute="video-card" class="video-card" style="display: block;">
        <video data-attribute="video" loop="" autoplay="" muted=""
          src="https://yurikoreanbeauty.com/cdn/shop/videos/c/vp/b2c1144b76fd4c0a8f80a25b101b0c44/b2c1144b76fd4c0a8f80a25b101b0c44.HD-1080p-7.2Mbps-57811310.mp4?v=0"></video>
      </div>
      <div data-show="false" data-attribute="image-card" class="image-card" style="display: none;">
        <img data-attribute="image" src="" alt="image">
      </div>
    </div>
  </div>
</div>
<div data-show="true" data-attribute="decor-bottom" data-color="#ffffff" class="decor-bottom"
  style="--color-decor: #ffffff; display: block;">
  <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
    <path d="M0,60 Q300,120 600,60 T1200,60 V120 H0 Z" fill="currentColor"></path>
  </svg>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#d23a70',
  textColor: '#000000',
  bottomPadding: false,
});
